var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14 8.94 5.44-5.44H15V2h5.94l.03-.03L21 2h1v1l.03.03-.03.03V9h-1.5V4.56L15.06 10zm-3.97 6.12L4.59 20.5h4.44V22H3.09l-.03.03-.03-.03h-1v-1L2 20.97l.03-.03V15h1.5v4.44L8.97 14z",
    clipRule: "evenodd"
  })));
};
export default SvgExpand;